import React from "react";
import { Box, Typography } from "@mui/material";
import NoQuoteIconSvg from "../../../../../assets/svg-fc/NoQuoteIconSvg";
import CoreButtons from "../../../../core-components/button/CoreButtons";
import { BUTTON_VARIANT, BUTTON_COLOR } from "../../../../../types/coreButtonTypes";
import "./quotesEmptyState.scss";

interface IQuotesEmptyStateProps {
	className?: string;
	onAddNewQuote?: () => void;
}

const QuotesEmptyState: React.FC<IQuotesEmptyStateProps> = ({ className, onAddNewQuote }) => {
	return (
		<Box className={`quotesEmptyState ${className || ""}`}>
			<Box className="quotesEmptyContent">
				<Box className="emptyIconContainer">
					<NoQuoteIconSvg />
				</Box>
				<Typography className="emptyStateTitle">No quotes</Typography>
				<Typography className="emptyStateText">
					To send a quote for this event, simply click the 'Add new quote' button.
				</Typography>
			</Box>
			<CoreButtons
				className="emptyStateButton"
				buttonText="Add new quote"
				variant={BUTTON_VARIANT.CONTAINED}
				color={BUTTON_COLOR.PRIMARY}
				fullWidth={false}
				coreBtnPill={true}
				onclick={onAddNewQuote}
			/>
		</Box>
	);
};

export default QuotesEmptyState;
